import { render, staticRenderFns } from "./NatureTalent.vue?vue&type=template&id=7c3d789c&"
import script from "./NatureTalent.vue?vue&type=script&lang=js&"
export * from "./NatureTalent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports